
<sale-profile
  v-if="$route.query.saleId"
  :id="$route.query.saleId"
/>

<post-view
  v-else-if="$route.query.postId"
  :id="$route.query.postId"
/>

<showcase-profile
  v-else-if="$route.query.showcaseCardId"
  :id="$route.query.showcaseCardId"
/>

<card-sales
  v-else-if="$route.query.showSales"
  :id="$route.query.cardId || $route.params.id"
/>

<profile-profile
  v-else-if="$route.query.profileId"
  :profile-id="$route.query.profileId"
/>

<card-profile
  v-else-if="$route.query.cardId"
  :id="$route.query.cardId"
  :profile-type="$route.query.profile"
/>
